import { Job, Answer } from "./interfaces";

// models the values from environment.json
export interface Environment {
  Prospect365MyPortalBaseUrl: string;
  IdentityServerBaseUrl: string;
  ODataBaseUrl: string;
  ClientId: string;
  ClaimPrefix: string;
  AuthUrl: string;
}

// models the initial state of the environment
export function GenerateUndefinedEnvironment(): Environment {
  return {
    Prospect365MyPortalBaseUrl: "",
    IdentityServerBaseUrl: "",
    ODataBaseUrl: "",
    ClientId: "",
    ClaimPrefix: "",
    AuthUrl: ""
  };
}

export function GenerateUndefinedJob(): Job {
  return {
    JobId: 0,
    JobDetail: undefined,
    ExamDetail: undefined,
    PartsDetail: undefined,
    ChecklistQAs: undefined
  };
}

export function GenerateUndefinedAnswerList(): Answer[] {
  return new Array();
}
